export enum KeycloakRealmRole {
    DASHBOARD_ADMIN = "dashboard-admin-showcase-user",
}
